import { render, staticRenderFns } from "./PlpCreatedLog.vue?vue&type=template&id=1be8d996"
import script from "./PlpCreatedLog.vue?vue&type=script&lang=js"
export * from "./PlpCreatedLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports